import { Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import InlineDownloadButton from 'ui-component/shared/InlineDownloadButton';

type RenderStyledTextProps = {
  value: string;
  tooltip?: string;
  color?:
    | 'warning'
    | 'success'
    | 'error'
    | 'info'
    | 'primary'
    | 'secondary'
    | 'grey';
  download?: string | undefined | null;
};

const RenderStyledText = ({
  value,
  tooltip,
  color,
  download,
}: RenderStyledTextProps) => {
  const theme = useTheme();
  const colorMap: { [key: string]: string } = {
    warning: theme.palette.warning.main,
    success: theme.palette.success.main,
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    grey: theme.palette.grey[500],
  };
  return (
    <Tooltip placement="top" title={tooltip || ''}>
      <Typography noWrap sx={{ ...(color ? { color: colorMap[color] } : {}) }}>
        {value}
        {download && <InlineDownloadButton link={download} />}
      </Typography>
    </Tooltip>
  );
};

export function renderStyledText(
  value: string,
  tooltip?: string,
  color?:
    | 'warning'
    | 'success'
    | 'error'
    | 'info'
    | 'primary'
    | 'secondary'
    | 'grey',
  download?: string | undefined | null
) {
  return (
    <RenderStyledText
      value={value}
      tooltip={tooltip}
      color={color}
      download={download}
    />
  );
}
